"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCachingTopic = void 0;
const react_1 = require("react");
/**
 * Create a new {@link push-rpc/core.Topic} that will cache invocations to Topic.get.
 *
 * To be used when multiple consumers use the same data from server:
 * ```
 * const {fields} = useForm()
 * const folders = useCachingTopic(services.folders)
 * ..
 * <div>Move files</div>
 * <Select label="From" field={fields.from} topic={folders}/>
 * <Select label="To" field={fields.to} topic={folders}/>
 * ```
 *
 * @param original
 */
function useCachingTopic(original) {
    const cache = (0, react_1.useRef)({}).current;
    const topic = {
        subscribe(consumer, params, subscriptionKey) {
            return original.subscribe(consumer, params, subscriptionKey);
        },
        unsubscribe(params, subscriptionKey) {
            return original.unsubscribe(params, subscriptionKey);
        },
        trigger(p) {
            original.trigger(p);
        },
        get(params) {
            const key = JSON.stringify(params == undefined ? null : params);
            if (!cache[key]) {
                cache[key] = original.get(params);
            }
            return cache[key];
        },
    };
    return topic;
}
exports.useCachingTopic = useCachingTopic;
